import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AccountingActionCreators from 'actions/AccountingActionCreators';
import InvoiceStore from 'stores/accounting/InvoiceStore';
import SessionStore from 'stores/SessionStore';
import AccountingWebAPIUtils from 'utils/AccountingWebAPIUtils';
import ShipmentWebAPIUtils, { downloadPODs, getShipmentByOid, } from 'utils/ShipmentWebAPIUtils';
import CargomaticCard from 'components/v2/card';
import CargomaticBadge from 'components/v2/Badge';
import ShipmentSearch from 'components/site/shipment-search';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import DollarIcon from 'components/v2/icons/DollarIcon';
import Spinner from 'components/ui/Spinner';
import DataPoller from 'components/ui/DataPoller';
import JobList from 'components/modules/accounting/JobList';
import CargomaticSelect from 'components/v2/select';
import { paymentMethods } from 'constants/accounting';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import Alert from 'components/ui/Alert';
import { showToast } from 'stores/ToastStore';
import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { Menu, Tab } from '@headlessui/react';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import CargomaticTab from 'components/v2/navs/Tab';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { transformPayload, transformRebillData, isValidInvoiceForCreditMemo, } from 'utils/credit-memo';
import CreditMemoModal from 'components/modules/shipments/accounting/CreditMemoModal';
import { generateCreditMemo } from 'utils/OrderWebAPIUtils';
import moment from 'moment';
import { get, cloneDeep, partition } from 'lodash';
import { CREDIT_MEMO, INVOICE } from 'config/documents';
import PaymentHistory from '../payment-history';
import PaymentSummary from '../payment-summary-v2';
import SendEmailModal from '../send-email-modal';
import LogPaymentModal from '../log-payment-modal';
import HistoryTable from '../history-table';
import { getDocumentsV2, getSignedUrl, getDocumentMetadata, } from '../../../../utils/DocumentsAPIUtils';
import { DOCUMENT_STATUSES } from '../../documents/Document';
import CreditMemoTable from './credit-memo';
import { DOCUMENT_METADATA_TYPE } from '../../../../constants/Documents';
const STRIPE = 'automated';
const ACH = 'manual';
var Loading = function () {
    return ((React.createElement("div", { "data-testid": "div-4b795707", className: "absolute justify-center w-full", style: { top: '50%' } },
        React.createElement("div", { "data-testid": "div-2f499e92", className: "align-middle" },
            React.createElement("span", { "data-testid": "span-694b47d2", className: "text-5xl text-green" },
                React.createElement(Spinner, { dataTestId: "Spinner-0fa95b56", showMessage: false }))))));
};
function getStateFromStores(invoiceId) {
    const invoice = InvoiceStore.getInvoice(invoiceId);
    let balance = 0;
    if (invoice)
        balance = invoice.amount_due;
    return {
        invoice: invoice,
        balance: balance,
        loading: false,
        editMode: false,
        updates: [],
    };
}
const JOBLIST_ACTIONS = {
    ADD: 'add',
    REMOVE: 'remove',
};
const options = {
    limit: 1,
    order: { field: 'updatedAt', direction: 'desc' },
};
class InvoiceDetails extends Component {
    constructor(props) {
        super(props);
        this.refetchTimeoutRef = React.createRef(0);
        this.getShipmentData = async (oid) => {
            const { t } = this.props;
            this.setState({ loading: true });
            try {
                const result = await getShipmentByOid(oid);
                this.setState({ shipment: result });
            }
            catch (e) {
                showToast(t('FAILED_TO_FETCH_SHIPMENT_DATA'), null, 'error');
                this.setState({ shipment: {} });
            }
            this.setState({ loading: false });
        };
        this.handleSaveCreditMemo = async (rebillData) => {
            const { t } = this.props;
            this.setState({ disableSaveCreditMemoButton: true }, async () => {
                var _a;
                try {
                    const { shipment, invoiceId, invoice } = this.state;
                    const adjustedItems = rebillData.adjustedItems.map((item) => {
                        return Object.assign(Object.assign({}, item), { notes: item.notes.trim() });
                    });
                    const data = {
                        rebill: rebillData.rebill,
                        adjustedItems,
                    };
                    const selectedCharges = transformPayload(data, shipment, invoice);
                    const rebillInformation = transformRebillData(data, shipment);
                    const sendEdi = true;
                    const invoiceCreatedDate = (invoice === null || invoice === void 0 ? void 0 : invoice.date_created) || new Date();
                    const result = await generateCreditMemo(shipment.order._id, invoiceId, invoiceCreatedDate, rebillInformation, selectedCharges, data.rebill, sendEdi);
                    this.setState({
                        showCreditMemoModal: false,
                        disableSaveCreditMemoButton: false,
                        disableCreditMemoOption: (_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.success,
                    });
                    showToast(t('CREDIT_MEMO_GENERATION_SUCCESS'));
                }
                catch (e) {
                    showToast(t('CREDIT_MEMO_GENERATION_FAILURE'), null, 'error');
                    this.setState({
                        showCreditMemoModal: false,
                        disableSaveCreditMemoButton: false,
                    });
                }
            });
        };
        this.getSelectedLineItem = (invoice = {}) => {
            let selectedLineItem = {};
            if (invoice && Object.keys(invoice).length) {
                const selectedInvoice = { _id: invoice._id, number: invoice.number };
                if (get(invoice, 'lineItemGroups[0].lineItems[0]', false)) {
                    selectedLineItem = Object.assign(Object.assign({}, invoice.lineItemGroups[0].lineItems[0]), { invoice: selectedInvoice });
                    return selectedLineItem;
                }
                selectedLineItem = { invoice: selectedInvoice };
            }
            return selectedLineItem;
        };
        this.showGetDocumentsErrorToast = (err) => {
            const { t } = this.props;
            showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', { error: err }), 'error');
        };
        this.showGetSignedUrlErrorToast = (err) => {
            const { t } = this.props;
            showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', { error: err }), 'error');
        };
        this.showGetDocumentMetadataErrorToast = (err) => {
            const { t } = this.props;
            showToast(t('GET_DOCUMENT_METADATA_ERROR'), t('GET_DOCUMENT_METADATA_FAILED_WITH_ERROR', { error: err }), 'error');
        };
        this.checkPricingManagerPermission = () => {
            const { t } = this.props;
            if (!this.state.isFinanceAdmin) {
                showToast(t('PERMISSION_REQUIRED'), t('PERMISSION_REQUIRED'), 'error');
                return false;
            }
            return true;
        };
        this.savePayment = (payment) => {
            AccountingActionCreators.recordPaymentForInvoice(this.state.invoiceId, payment);
        };
        this.handleInvoiceRegenerateUpdate = async () => {
            var _a;
            if (!InvoiceStore.getInvoiceRegenerationStatus()) {
                const invoice = InvoiceStore.getUpdatedInvoice();
                const { data, errors } = await getDocumentsV2([this.state.invoiceId], null, options);
                if (errors) {
                    this.showGetDocumentsErrorToast(errors[0].message);
                    return;
                }
                const invoiceDoc = (_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents[0];
                let invoiceStatus = invoiceDoc.status;
                this.refetchTimeoutRef.current = setInterval(async () => {
                    var _a, _b, _c, _d;
                    if (invoiceStatus !== DOCUMENT_STATUSES.PENDING) {
                        clearTimeout(this.refetchTimeoutRef.current);
                        const { data: signedUrl, errors: signedUrlErrors } = await getSignedUrl(invoiceDoc.key);
                        if (signedUrlErrors) {
                            this.showGetSignedUrlErrorToast(signedUrlErrors[0].message);
                        }
                        const linkToInvoice = (_a = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl;
                        this.setState({ regenerating: false, invoice, linkToInvoice });
                    }
                    else {
                        const { data, errors } = await getDocumentsV2([this.state.invoiceId], null, options);
                        if (errors) {
                            this.showGetDocumentsErrorToast(errors[0].message);
                            return;
                        }
                        invoiceStatus = (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.status;
                    }
                }, 2000);
            }
        };
        this.regenerateInvoice = (_id, type, data) => {
            this.setState({ regenerating: true }, () => AccountingWebAPIUtils.regenerateInvoice(_id, type, data));
        };
        this.sendEdiInvoice = async () => {
            var _a;
            try {
                const response = await AccountingWebAPIUtils.sendEdiInvoice(this.state.invoice._id);
                if (response.entity && ((_a = response === null || response === void 0 ? void 0 : response.entity) === null || _a === void 0 ? void 0 : _a.success)) {
                    AccountingActionCreators.getInvoice(this.state.invoice._id);
                }
            }
            catch (e) {
                showToast(e.message, null, 'error');
            }
        };
        this.handlePaymentMethodSelect = (data) => {
            const { name } = data;
            if (!name) {
                return;
            }
            const method = name.toLowerCase();
            if (method && method !== this.state.paymentMethod) {
                this.setState({ paymentMethod: method });
                const method_value = method === 'manual/ach' ? 'manual' : 'automated';
                AccountingWebAPIUtils.setInvoicePaymentMethod(method_value, this.state.invoiceId);
            }
        };
        this.handleJobRemove = async (invoice, lineItem) => {
            var _a, _b;
            try {
                const updatedJobIds = invoice.jobs.filter((id) => id !== lineItem.shipment_id);
                this.setState({ showLineItemConfirmModal: false });
                const newInvoice = await AccountingWebAPIUtils.updateInvoiceJobs(invoice, updatedJobIds, JOBLIST_ACTIONS.REMOVE);
                const { data, errors } = await getDocumentsV2([this.state.invoiceId], null, options);
                if (errors) {
                    this.showGetDocumentsErrorToast(errors[0].message);
                    return;
                }
                const invoiceDoc = (_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents[0];
                const { data: signedUrl, errors: signedUrlErrors } = await getSignedUrl(invoiceDoc.key);
                if (signedUrlErrors) {
                    this.showGetSignedUrlErrorToast(signedUrlErrors[0].message);
                }
                const linkToInvoice = (_b = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _b === void 0 ? void 0 : _b.signedUrl;
                const lineItems = await this.getLineItems(newInvoice);
                this.setState({
                    invoice: newInvoice,
                    lineItems,
                    linkToInvoice,
                    confirmModal: this.confirmModalDefault(),
                });
            }
            catch (e) {
                showToast(e.message, null, 'error');
            }
        };
        this.handleSearch = async (invoice, value, job) => {
            if (!this.checkPricingManagerPermission())
                return;
            const listOfJobIdsAssociated = invoice.lineItemGroups;
            const searchedShipmentId = job.shipmentId;
            let listOfJobs = [];
            listOfJobs = _.filter(listOfJobIdsAssociated, (jobsAssociated) => jobsAssociated.shipmentId === searchedShipmentId);
            this.setState({ selectedValue: value });
            if (listOfJobs.length) {
                invoice.lineItemGroups = listOfJobs;
                this.setState({ invoice: invoice });
            }
        };
        this.onSelectChange = async (value) => {
            const invoiceState = await getStateFromStores(this.state.invoiceId);
            const { selectedValue } = this.state;
            const { lineItemGroups } = invoiceState.invoice;
            value = value.trim().toUpperCase();
            if (value.length && value !== selectedValue) {
                let listOfJobs = [];
                listOfJobs = _.filter(lineItemGroups, (lineItemGroup) => {
                    if (lineItemGroup.shipmentId.includes(value))
                        return lineItemGroup;
                });
                if (listOfJobs.length) {
                    invoiceState.invoice.lineItemGroups = listOfJobs;
                    this.setState({ invoice: invoiceState.invoice });
                }
                else {
                    invoiceState.invoice.lineItemGroups = [];
                    this.setState({ invoice: invoiceState.invoice });
                }
            }
            else {
                this.setState(this.getInitialState());
            }
            return null;
        };
        this.setChanges = (updates) => {
            const { editMode } = this.state;
            this.setState({ updates });
            if (!editMode) {
                this.setState({ editMode: true });
            }
        };
        this.confirmModalDefault = () => {
            return {
                title: '',
                message: '',
                onConfirm: null,
            };
        };
        this.confirmRemoveShipment = (job) => {
            if (!this.checkPricingManagerPermission())
                return;
            const { t } = this.props;
            const title = t('REMOVE_SHIPMENT_FROM_INVOICE_TITLE', {
                shipment_id: job.shipmentId,
            });
            const message = t('REMOVE_SHIPMENT_FROM_INVOICE_MESSAGE');
            this.setState((prevState) => ({
                showLineItemConfirmModal: true,
                confirmModal: {
                    title,
                    message,
                    onConfirm: () => this.handleJobRemove(prevState.invoice, job),
                },
            }));
        };
        this.handlePODDownload = () => {
            this.setState({ downloadingPods: true }, async () => {
                try {
                    await downloadPODs({ invoiceId: this.state.invoice._id });
                    this.setState({ downloadingPods: false });
                }
                catch (e) {
                    this.setState({ downloadingPods: false });
                    showToast(e.message, null, 'error');
                }
            });
        };
        this.isDebitInvoiceType = () => {
            var _a, _b;
            return (!((_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.invoice_type) ||
                ((_b = this.state.invoice) === null || _b === void 0 ? void 0 : _b.invoice_type) === 'debit');
        };
        this.renderCreditMemoSummary = () => {
            const { t } = this.props;
            const { total, original_invoice, currency } = this.state.invoice;
            return ((React.createElement("div", { "data-testid": "div-224410bc", className: "grid grid-cols-2 gap-y-4 gap-x-2" },
                React.createElement("div", { "data-testid": "div-a341d6f1" },
                    React.createElement(DescriptionListItem, { dataTestId: "DescriptionListItem-252c8556", label: titleize(t('CREDIT')) },
                        React.createElement("div", { "data-testid": "div-490312d6", className: "text-red-500 font-medium" }, formatMoney(total, currency)))),
                React.createElement("div", { "data-testid": "div-e4d6468e" },
                    React.createElement(DescriptionListItem, { dataTestId: "DescriptionListItem-785eb8d3", label: titleize(t('CREDITED_INVOICE')) },
                        React.createElement("div", { "data-testid": "div-59b279f5" },
                            React.createElement("a", { "data-testid": "a-b0a4e65d", href: `/invoices/${original_invoice === null || original_invoice === void 0 ? void 0 : original_invoice.id}`, target: "_blank", rel: "noreferrer" }, original_invoice === null || original_invoice === void 0 ? void 0 : original_invoice.number)))))));
        };
        this.openCreditMemoModal = () => {
            if (this.state.canGenerateCreditMemo) {
                this.setState({ showCreditMemoModal: true });
            }
        };
        this.state = {
            loading: true,
            downloadingPods: false,
            selectedValue: '',
            invoiceId: props.invoiceId || props.match.params.id,
            showSendEmailModal: false,
            lineItems: [],
            isAdmin: SessionStore.isAdmin(),
            paymentMethod: null,
            showLineItemConfirmModal: false,
            confirmModal: this.confirmModalDefault(),
            isFinanceAdmin: SessionStore.isFinanceAdmin(),
            hasFinanceAdminRole: SessionStore.hasFinanceAdminRole(),
            invoice: {},
            canGenerateCreditMemo: SessionStore.canGenerateCreditMemo(),
            showCreditMemoModal: false,
            disableSaveCreditMemoButton: false,
            shipment: {},
            selectedLineItem: {},
            disableCreditMemoOption: false,
            invoiceErrors: null,
        };
    }
    async processDocumentMetadata(invoiceId, invoiceState, docsArr) {
        const { t } = this.props;
        if (!docsArr && !docsArr.length) {
            return;
        }
        try {
            const findDocIndex = (fileName, fileId) => {
                return (
                // increment array item index to human-understandable
                (docsArr
                    .filter((doc) => doc.name === fileName)
                    .sort((a, b) => {
                    if (moment(a.createdAt).isAfter(b.createdAt)) {
                        return 1;
                    }
                    return -1;
                })
                    .findIndex((doc) => doc.id === fileId) + 1));
            };
            const { data: { getDocumentMetadata: { data }, }, errors: getDocumentMetadataErrors, } = await getDocumentMetadata(invoiceId);
            if (getDocumentMetadataErrors) {
                this.showGetDocumentMetadataErrorToast(getDocumentMetadataErrors[0].message);
                return;
            }
            if ((data === null || data === void 0 ? void 0 : data.metadataType) === DOCUMENT_METADATA_TYPE.CombinePDFError &&
                (data === null || data === void 0 ? void 0 : data.metadata)) {
                const metadata = JSON.parse(data.metadata);
                const body = Object.keys(metadata)
                    .map((fileId) => {
                    const fileItem = metadata[fileId];
                    return `${fileItem.name} #${findDocIndex(fileItem.name, fileId)}: ${fileItem.message}`;
                })
                    .join('/n');
                this.setState(Object.assign(Object.assign({}, invoiceState), { invoiceErrors: {
                        title: t('SOME_INVOICE_FILES_WERE_NOT_APPENDED'),
                        body,
                    } }));
            }
        }
        catch (e) {
            showToast(e.message, null, 'error');
        }
    }
    async componentDidMount() {
        InvoiceStore.register(this.onChange.bind(this));
        AccountingActionCreators.getInvoice(this.state.invoiceId, SessionStore.getUserType());
        InvoiceStore.addChangeListener(this.handleInvoiceRegenerateUpdate);
    }
    componentWillUnmount() {
        InvoiceStore.unregister(this.onChange);
        InvoiceStore.removeChangeListener(this.handleInvoiceRegenerateUpdate);
    }
    componentDidUpdate(prevProps) {
        if (this.props.invoiceId !== prevProps.invoiceId) {
            this.setState({
                invoiceId: this.props.invoiceId,
            });
            AccountingActionCreators.getInvoice(this.props.invoiceId, SessionStore.getUserType());
        }
    }
    async getLineItems(invoice) {
        try {
            const jobIds = invoice.jobs.map((job) => job._id || job);
            const lineItemsResult = await ShipmentWebAPIUtils.getShipmentsLedgers(jobIds, 'invoice');
            const currentJobLineItems = invoice.lineItemGroups.map((job) => {
                return {
                    _id: job.shipment_id,
                    receivables: job.lineItems.map((lineItem) => (Object.assign(Object.assign({}, lineItem), { invoice_id: invoice._id }))),
                };
            });
            return invoice.status === 'paid'
                ? currentJobLineItems
                : lineItemsResult.items || [];
        }
        catch (e) {
            console.log('Error in get line items: ', e);
        }
    }
    async onChange() {
        var _a, _b, _c, _d, _e, _f;
        const result = getStateFromStores(this.state.invoiceId);
        try {
            const invoiceState = cloneDeep(result);
            if (invoiceState === null || invoiceState === void 0 ? void 0 : invoiceState.invoice) {
                if (((_b = (_a = invoiceState.invoice) === null || _a === void 0 ? void 0 : _a.jobs) === null || _b === void 0 ? void 0 : _b.length) &&
                    !Object.keys(this.state.shipment).length) {
                    await this.getShipmentData(invoiceState.invoice.jobs[0]);
                }
                const { data, errors } = await getDocumentsV2([this.state.invoiceId, (_c = this.state.shipment) === null || _c === void 0 ? void 0 : _c._id], null, Object.assign(Object.assign({}, options), { limit: 100 }));
                if (errors) {
                    this.showGetDocumentsErrorToast(errors[0].message);
                    return;
                }
                const [targetDocsArr, docsArr] = partition((_d = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _d === void 0 ? void 0 : _d.documents, [
                    'type',
                    ((_e = invoiceState.invoice) === null || _e === void 0 ? void 0 : _e.invoice_type) === 'credit'
                        ? CREDIT_MEMO.value
                        : INVOICE.value,
                ]);
                const targetDoc = targetDocsArr[0];
                const { data: signedUrl, errors: signedUrlErrors } = await getSignedUrl(targetDoc === null || targetDoc === void 0 ? void 0 : targetDoc.key);
                if (targetDoc) {
                    await this.processDocumentMetadata(targetDoc.id, invoiceState, docsArr);
                }
                const linkToInvoice = (_f = signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.getSignedUrl) === null || _f === void 0 ? void 0 : _f.signedUrl;
                if (signedUrlErrors) {
                    this.showGetSignedUrlErrorToast(signedUrlErrors[0].message);
                }
                const lineItems = await this.getLineItems(invoiceState.invoice);
                this.setState(Object.assign(Object.assign({}, invoiceState), { regenerating: false, linkToInvoice,
                    lineItems }));
            }
        }
        catch (e) {
            showToast(e.message, null, 'error');
        }
    }
    sendEmail() {
        var _a;
        const invoice_type = ((_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.invoice_type) || 'debit';
        const isCreditMemo = invoice_type === 'credit';
        return (emails) => {
            AccountingActionCreators.emailInvoice(this.state.invoiceId, emails, isCreditMemo);
        };
    }
    getDownloadButtonType() {
        var _a;
        const { t } = this.props;
        const invoice_type = ((_a = this.state.invoice) === null || _a === void 0 ? void 0 : _a.invoice_type) || 'debit';
        switch (invoice_type) {
            case 'credit':
                return t('DOWNLOAD_CREDIT_MEMO');
            case 'managed':
                return t('DOWNLOAD_MANAGED_INVOICE');
            default:
                return t('DOWNLOAD_INVOICE');
        }
    }
    renderAuditHistory() {
        const { t } = this.props;
        const { invoice } = this.state;
        return ((React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-cd9f4bb2", className: "mb-6", header: () => (React.createElement("div", { "data-testid": "div-df541775", className: "flex items-center justify-between" },
                React.createElement("h3", { "data-testid": "h3-b0024c5d", className: "my-0 mr-8" }, t('AUDIT_HISTORY')))) },
            React.createElement("div", { "data-testid": "div-ba5da982", className: "-mb-4 card--no-x-padding card--no-top-padding" },
                React.createElement(HistoryTable, { data: invoice.audit || [], type: "Invoice" })))));
    }
    defineDropdownSelectedValue() {
        const { paymentMethod, invoice: { payment_method }, } = this.state;
        if (paymentMethod) {
            return paymentMethod === 'automated' ? STRIPE : ACH;
        }
        if (payment_method) {
            return payment_method === 'automated' ? STRIPE : ACH;
        }
        return null;
    }
    getTabNames() {
        const { t } = this.props;
        const tabs = [
            {
                slug: 'lineItems',
                name: t('LINE_ITEMS'),
            },
            {
                slug: 'auditHistory',
                name: t('AUDIT_HISTORY'),
            },
        ];
        return ((React.createElement(Tab.Group, null,
            React.createElement(Tab.List, null,
                React.createElement("div", { "data-testid": "div-636ea195", className: "space-x-4" }, tabs.map((tab, index) => (React.createElement(CargomaticTab, { dataTestId: `CargomaticTab-a56d2f2a-${index}`, tab: tab }))))),
            React.createElement(Tab.Panels, { className: "mt-6" },
                React.createElement(Tab.Panel, null, this.renderJobs()),
                React.createElement(Tab.Panel, null, this.renderAuditHistory())))));
    }
    renderActionDropdown() {
        var _a, _b, _c;
        const { t } = this.props;
        const { invoice, isAdmin, disableCreditMemoOption } = this.state;
        const { _id, type, order } = invoice;
        const orderId = order && order._id ? order._id : order;
        const invoice_type = (invoice === null || invoice === void 0 ? void 0 : invoice.invoice_type) || 'debit';
        const date_created = (invoice === null || invoice === void 0 ? void 0 : invoice.date_created) || new Date();
        const isMultiJobInvoice = ((_a = invoice === null || invoice === void 0 ? void 0 : invoice.jobs) === null || _a === void 0 ? void 0 : _a.length) > 1;
        const disabledText = isMultiJobInvoice
            ? t('CREDIT_MEMO_GENERATION_ERROR')
            : t('DISABLED');
        const data = {
            orderId,
            invoiceDate: date_created,
        };
        const disableCMBtn = ((invoice === null || invoice === void 0 ? void 0 : invoice.credit_memos) || []).length ||
            disableCreditMemoOption ||
            isMultiJobInvoice;
        return ((React.createElement("div", { "data-testid": "div-3dd77e47", className: "flex flex-wrap px-2 items-end -mx-2" },
            React.createElement(DataPoller, { dataTestId: "DataPoller-32de1597", frequency: 60000, action: () => this.onChange() }),
            React.createElement(DropdownMenu, { dataTestId: "DropdownMenu-a3273dc6", title: t('ACTIONS') },
                this.state.canGenerateCreditMemo &&
                    isValidInvoiceForCreditMemo(invoice) && (React.createElement(Menu.Item, { "data-testid": "undefined-0a7ca86f", key: "create_credit_memo" },
                    React.createElement(DropdownItem, { dataTestId: "DropdownItem-15d5b898", disabledText: disabledText, onClick: this.openCreditMemoModal, disabled: disableCMBtn }, t('CREATE_CREDIT_MEMO')))),
                React.createElement(Menu.Item, { "data-testid": "undefined-06d0be7b", key: "invoice_download" },
                    React.createElement(DropdownItem, { dataTestId: "DropdownItem-37a70b3c", disabled: !((_b = this === null || this === void 0 ? void 0 : this.state) === null || _b === void 0 ? void 0 : _b.linkToInvoice), href: this.state.linkToInvoice, target: "_blank", rel: "noopener noreferrer" }, this.getDownloadButtonType())),
                this.isDebitInvoiceType() && (React.createElement(Menu.Item, { "data-testid": "undefined-3494e25c", key: "download_pods" },
                    React.createElement(DropdownItem, { dataTestId: "DropdownItem-e93e9736", disabled: this.state.downloadingPods, onClick: () => this.handlePODDownload() }, t('DOWNLOAD_PODS')))),
                React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                    React.createElement(Menu.Item, { "data-testid": "undefined-d4f865ae", key: "email_invoice" },
                        React.createElement(DropdownItem, { dataTestId: "DropdownItem-fea468d1", disabled: !((_c = this === null || this === void 0 ? void 0 : this.state) === null || _c === void 0 ? void 0 : _c.linkToInvoice), onClick: () => {
                                this.setState({ showSendEmailModal: true });
                            } }, invoice_type === 'credit'
                            ? t('EMAIL_CREDIT_MEMO')
                            : t('EMAIL_INVOICE')))),
                isAdmin && this.isDebitInvoiceType() && (React.createElement(Menu.Item, { "data-testid": "undefined-59d48511", key: "regenerate_invoice" },
                    React.createElement(DropdownItem, { dataTestId: "DropdownItem-ad70acb8", onClick: () => this.regenerateInvoice(_id, type, data), disabled: this.state.regenerating }, t('REGENERATE_INVOICE')))),
                isAdmin && this.isDebitInvoiceType() && !invoice.edi_sent && (React.createElement(Menu.Item, { "data-testid": "undefined-32ae2878", key: "send_edi" },
                    React.createElement(DropdownItem, { dataTestId: "DropdownItem-9bd3de2b", onClick: this.sendEdiInvoice }, t('SEND_EDI'))))))));
    }
    renderPaymentMethod() {
        const { hasFinanceAdminRole } = this.state;
        const { t } = this.props;
        return ((React.createElement("div", { "data-testid": "div-55589ad4", className: "px-2" },
            React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-289f8dac", items: paymentMethods, onSelect: this.handlePaymentMethodSelect, label: t('PAYMENT_METHOD'), disabled: !hasFinanceAdminRole, caption: t('SELECT_PAYMENT_METHOD'), valueKey: "value", textKey: "localizationSlug", selected: this.defineDropdownSelectedValue(), info: t('PAYMENT_METHOD_TOOLTIP_MESSAGE') }))));
    }
    renderJobs() {
        const { t } = this.props;
        const { invoice } = this.state;
        return ((React.createElement("div", { "data-testid": "div-e405f914", className: "" },
            React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-791e6868", className: "mt-6 lg:mt-0", header: () => {
                    return ((React.createElement("div", { "data-testid": "div-fb14015f", className: "flex items-center justify-between" },
                        React.createElement("div", { "data-testid": "div-1e41114c", className: "flex items-center space-x-2" },
                            React.createElement("h3", { "data-testid": "h3-81d1421d", className: "my-0" }, t('JOBS')),
                            React.createElement("div", { "data-testid": "div-8a097c30", className: "w-60" },
                                React.createElement(ShipmentSearch, { isFilter: true, lineItemGroups: invoice.lineItemGroups, dataTestId: "ShipmentSearch-ja42ew24", onSelect: (value, job) => {
                                        this.handleSearch(invoice, value, job);
                                    }, onChange: (value) => this.onSelectChange(value), disabled: !this.state.isFinanceAdmin }))))));
                } },
                React.createElement("div", { "data-testid": "div-da8ec85c", className: "-mb-4 card--no-x-padding card--no-top-padding sm:-mb-4" },
                    React.createElement(JobList, { context: "invoice", ledgerType: invoice.type, ledgerId: invoice._id, version: invoice.version, jobs: invoice.lineItemGroups, lineItems: this.state.lineItems, onRemove: this.confirmRemoveShipment, editMode: this.state.editMode, setChanges: this.setChanges, hideButtons: !this.state.editMode || invoice.status === 'paid' }))))));
    }
    renderInvoice() {
        var _a, _b;
        const { t } = this.props;
        const { invoice, isAdmin, invoiceErrors } = this.state;
        const { title, message, onConfirm } = this.state.confirmModal;
        const showInvoiceErrors = invoiceErrors && !_.isEmpty(invoiceErrors);
        return ((React.createElement("div", { "data-testid": "div-f104d4f9", className: "mx-auto my-8 sm:my-16 lg:my-8 max-w-screen-2xl" },
            React.createElement("div", { "data-testid": "div-95c6ad45", className: "flex flex-wrap items-center justify-between mb-8" },
                React.createElement("div", { "data-testid": "div-dcc89370", className: "flex items-center mb-4 space-x-3" },
                    React.createElement("h2", { "data-testid": "h2-0c2badfe", className: "my-0" }, invoice.number),
                    showInvoiceErrors && (React.createElement(Alert, { dataTestId: "Alert-4eedc2d6", className: "flex-1", type: "warning", title: invoiceErrors.title },
                        React.createElement("div", { "data-testid": "div-57ba8b68" }, invoiceErrors.body))),
                    isAdmin && this.isDebitInvoiceType() && invoice.edi_sent && (React.createElement(CargomaticBadge, { dataTestId: "CargomaticBadge-c98247c2", color: "green", size: "large" }, t('EDI_SENT')))),
                React.createElement("div", { "data-testid": "div-b74b2c26", className: "flex justify-end items-end" },
                    isAdmin && this.isDebitInvoiceType() && this.renderPaymentMethod(),
                    this.renderActionDropdown())),
            React.createElement("div", { "data-testid": "div-88cad8f9", className: "w-full lg:grid lg:grid-cols-4 lg:gap-4" },
                React.createElement("div", { "data-testid": "div-a8510b2f", className: "col-span-1" },
                    React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-73c22a16", className: "mb-6 pb-6", removeBorders: true, removeVerticalPadding: true, rem: true, header: () => React.createElement("h3", { "data-testid": "h3-c48bff33", className: "m-0" }, t('SUMMARY')) },
                        React.createElement("div", { "data-testid": "div-dcf12d25", className: "" }, (this.isDebitInvoiceType() && (React.createElement(PaymentSummary, { total: invoice.total, paid: invoice.total_payments, balance: invoice.amount_due, credit_memos: invoice.credit_memos || [], currency: invoice === null || invoice === void 0 ? void 0 : invoice.currency }))) ||
                            this.renderCreditMemoSummary()))),
                this.isDebitInvoiceType() && (React.createElement("div", { "data-testid": "div-6a6d990a", className: "col-span-3" },
                    React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-b4f3bb2f", className: "mb-6", header: () => (React.createElement("div", { "data-testid": "div-ae7b89a5", className: "flex items-center justify-between" },
                            React.createElement("h3", { "data-testid": "h3-557e344a", className: "my-0 mr-8" }, t('PAYMENTS')),
                            isAdmin && (React.createElement("button", { "data-testid": "button-17f95155", className: "button button-green button-with-icon", onClick: () => {
                                    this.setState({ showLogPaymentModal: true });
                                } },
                                React.createElement(DollarIcon, null),
                                React.createElement("span", { "data-testid": "span-cd1aef36" }, t('RECORD_PAYMENT')))))) },
                        React.createElement("div", { "data-testid": "div-056e5d26", className: "mb-2 -mb-4 card--no-x-padding card--no-top-padding sm:-mb-4" },
                            React.createElement(PaymentHistory, { payments: ((_a = invoice.payments) === null || _a === void 0 ? void 0 : _a.filter((payment) => payment.type === 'payment')) || [], currency: invoice === null || invoice === void 0 ? void 0 : invoice.currency })))))),
            invoice.invoice_type !== 'credit' &&
                ((_b = invoice.credit_memos) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("div", { "data-testid": "div-021c9cc1", className: "w-full lg:grid lg:grid-cols-4 lg:gap-4" },
                React.createElement("div", { "data-testid": "div-c6141e38", className: "col-start-2 col-end-5" },
                    React.createElement(CreditMemoTable, { creditMemoList: invoice.credit_memos })))),
            this.getTabNames(),
            React.createElement(SendEmailModal, { show: this.state.showSendEmailModal, onSend: this.sendEmail(), onHide: () => this.setState({ showSendEmailModal: false }) }),
            this.state.showLogPaymentModal && (React.createElement(LogPaymentModal, { show: this.state.showLogPaymentModal, amount: (this.state.balance || 0).toFixed(2), onSave: this.savePayment, onHide: () => this.setState({ showLogPaymentModal: false }) })),
            this.state.showCreditMemoModal && (React.createElement(CreditMemoModal, { selectedLineItem: this.getSelectedLineItem(this.state.invoice), show: this.state.showCreditMemoModal, shipment: this.state.shipment, onClose: () => this.setState({ showCreditMemoModal: false }), disableSave: this.state.disableSaveCreditMemoButton, onSave: (data) => this.handleSaveCreditMemo(data) })),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-d648aa58", show: this.state.showLineItemConfirmModal, title: title, message: message, onConfirm: onConfirm, onHide: () => this.setState({ showLineItemConfirmModal: false }) }))));
    }
    render() {
        if (this.state.loading) {
            return React.createElement(Loading, null);
        }
        return this.renderInvoice();
    }
}
InvoiceDetails.propTypes = {
    match: PropTypes.object.isRequired,
    invoiceId: PropTypes.string,
};
export default withTranslation()(InvoiceDetails);
